module.exports = __webpack_public_path__ + "static/media/twitter-icon.f0f34f62.svg";